import type { TranslationMessages } from '../../types';

export const ranking: TranslationMessages = {
  title: 'Ranking Board',
  leaderboard: 'Leaderboard',
  personal_ranking: 'Personal Ranking',
  your_rank: 'Your Rank',
  your_score: 'Your Score',
  percentile: 'Percentile',
  ranking_criteria: 'Ranking Criteria',
  attitude: 'Attitude',
  customer_feedback: 'Customer Feedback',
  working_quality: 'Working Quality',
  attendance: 'Attendance',
  overall: 'Overall',
  top_performers: 'Top Performers',
  rank: 'Rank',
  score: 'Score',
  change_criteria: 'Change Criteria',
  apply_criteria: 'Apply Criteria',
  monthly_reset: 'Monthly Reset',
  quarterly_reset: 'Quarterly Reset',
  no_rankings: 'No rankings available',
};
